import SalesDealsApi from 'api/admins/sales-deals-api'
import { TitlePage } from 'components/atoms'
import SalesDealsView from 'domains/sales/deals/view/sales-deal-view'
import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router'

const propTypes = {
  pageUtils: PropTypes.shape({
    setAlertMsg    : PropTypes.func,
    setApiErrorMsg : PropTypes.func
  })
}

const SalesDealsDetailPage = ({ pageUtils }) => {
  const { id } = useParams()
  const [ deal, setDeal ] = useState({})
  const [ historyList, setHistoryList ] = useState([])
  const [ historyDetail, setHistoryDetail ] = useState({})
  const [ isLoading, setIsLoading ] = useState(true)

  const cancelDeal = () => {
    setIsLoading(true)

    SalesDealsApi.cancel({ dealId: id })
      .then((response) => {
        if(response.status === 200){
          fetchDeal()
        }
      })
      .catch((error) => pageUtils.setApiErrorMsg(error.response.data.message))
      .finally(() => { setIsLoading(false) })
  }

  const fetchDeal = () => {
    setIsLoading(true)

    SalesDealsApi.show({ dealId: id })
      .then((response) => { setDeal(response.data.data) })
      .catch((error) => pageUtils.setApiErrorMsg(error.response.data.message))
      .finally(() => { setIsLoading(false) })
  }

  const fetchHistoryList = () => {
    SalesDealsApi.listHistory({ dealId: id })
      .then((response) => {
        setHistoryList(
          (response.data?.data || []).sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
        )
      })
      .catch((error) => pageUtils.setApiErrorMsg(error.response.data.message))
  }

  const fetchHistoryDetail = (historyId) => {
    SalesDealsApi.getHistory({ historyId })
      .then((response) => { setHistoryDetail(response.data.data) })
      .catch((error) => pageUtils.setApiErrorMsg(error.response.data.message))
  }

  const clearHistoryDetail = () => {
    setHistoryDetail({})
  }

  useEffect(() => {
    fetchDeal()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ id ])

  return (
    <>
      <TitlePage mainTitle={ 'Sales Deal' }/>
      <SalesDealsView
        cancelDeal={ cancelDeal }
        fetchDeal={ fetchDeal }
        fetchHistoryList={ fetchHistoryList }
        fetchHistoryDetail={ fetchHistoryDetail }
        clearHistoryDetail={ clearHistoryDetail }
        deal={ deal }
        historyList={ historyList }
        historyDetail={ historyDetail }
        isLoading={ isLoading }
      />
    </>
  )
}

SalesDealsDetailPage.propTypes = propTypes

export default SalesDealsDetailPage
